module.exports = __webpack_public_path__ + "static/media/ic_higher_returns.d86df175.svg";